export enum LicenseTypes {
  NONE = "None",
  FOREIGN = "Foreign Drivers Licence",
  RSA = "RSA Drivers Licence",
  RSA_LEARNERS = "RSA Learners Licence",
}
